import React from 'react';

import { StoreIcon, PhoneIcon, EmailIcon } from 'assets/common_svgs';
import {
  grey70,
  cefRed,
  white,
} from '../../../assets/stylesheets/v2/abstracts/_variables.scss';

/**
 * @param {Object} props
 * @param {boolean} props.catalogue - current product catalogue number
 * @param {boolean} props.selectAStoreUrl - URL for select a store page
 * @param {function} props.currentStore - current Store if present
 * @param {boolean} props.currentProductName - current product name
 * @param {function} props.showTelephoneLink - Bool for show telephone link
 * @param {function} props.showEmailLink - Bool for show email link
 * @param {function} props.showStoreIcon - Bool for show store icon in title
 * @param {function} props.emailIconWidth - email icon width
 * @param {function} props.emailIconHeight - email icon height
 * @returns Store address box for renewables product
 */

const StoreAddressBox = ({
  catalogue,
  selectAStoreUrl,
  currentStore: {
    Name: name,
    Address1: address1,
    Address2: address2,
    Address3: address3,
    Address4: address4,
    Address5: address5,
    Postcode: postcode,
    Email: email,
    Telephone: telephone,
  },
  currentProductName,
  showTelephoneLink,
  showEmailLink,
  showStoreIcon,
  emailIconWidth,
  emailIconHeight,
}) => (
  <>
    <div
      className={`current-store__container ${
        showStoreIcon
          ? 'current-store__container--with-border current-store__container--with-padding'
          : ''
      }`}>
      <div className="current-store__title fl ai-c">
        {showStoreIcon && (
          <StoreIcon width={22} height={40} fillColour={grey70} />
        )}
        <p className={`${showStoreIcon ? 'mlr-5' : ''}`}>{name} Store</p>
        <a href={selectAStoreUrl} className="td-u">
          Change
        </a>
      </div>
      <div className="current-store__address-box ta-l">
        {address1 && <span>{address1} </span>}
        {address2 && <span>{address2} </span>}
        {address3 && <span>{address3} </span>}
        {address4 && <span>{address4} </span>}
        {address5 && <span>{address5} </span>}
        {postcode && <span>{postcode} </span>}
      </div>
      {showTelephoneLink && (
        <>
          <div className="current-store__telephone">
            <PhoneIcon width={20} height={20} fillColour={cefRed} />
            <span>{telephone}</span>
          </div>
          <a
            className="current-store__telephone-link"
            href={`tel:${telephone}`}>
            <PhoneIcon width={20} height={20} fillColour={white} />
            Call Store
          </a>
        </>
      )}

      {showEmailLink && (
        <a
          href={`mailto:${email}?subject=Enquiry - ${currentProductName} - ${catalogue}`}
          target="_blank"
          rel="noopener noreferrer"
          className="current-store__email-link cef-btn cef-btn--full-width fs-16 fw-500">
          <EmailIcon
            width={emailIconWidth || 26}
            height={emailIconHeight || 16}
            fillColour={white}
          />
          <span className="ml-6">Email Store</span>
        </a>
      )}
    </div>
  </>
);

export default StoreAddressBox;
